import {
  FIT_COMPATIBILITY,
  FIT_COMPATIBILITY_DRAWER,
  FIT_COMPATIBILITY_DRAWER_CALCULATE_FIT,
  FIT_COMPATIBILITY_DRAWER_CHECKOUT,
  FIT_COMPATIBILITY_STEP4,
  INTERACTION,
  NOT_APPLICABLE,
  OVERLAY,
  PIP_SUB_CONTENT
} from '../constants';

export const fitCompatibility = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('fit-compatibility-drawer.drawerOpen', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: FIT_COMPATIBILITY_DRAWER
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('fit-compatibility-drawer.checkout.drawerOpen', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: FIT_COMPATIBILITY_DRAWER_CHECKOUT
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

  window.LIFE_CYCLE_EVENT_BUS.on('fit-compatibility-drawer.step4', ({ output }) => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: FIT_COMPATIBILITY_STEP4
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });

    window.LIFE_CYCLE_EVENT_BUS.on('fit-compatibility-drawer.calculateFit', () => {
    const ddoEvent = {
      category: {
        primaryCategory: INTERACTION
      },
      eventInfo: {
        eventName: PIP_SUB_CONTENT
      },
      subContent: {
        component: FIT_COMPATIBILITY,
        section: FIT_COMPATIBILITY_DRAWER_CALCULATE_FIT,
        target: NOT_APPLICABLE
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};
